/**
 * Site-wide constants for TypingWhiz.
 * Safe to import from both server and client components.
 *
 * @module lib/constants/site
 */

export const SITE_NAME = 'TypingWhiz';
export const SITE_DESCRIPTION =
  'Learn to type faster and more accurately with structured lessons, ' +
  'typing tests, free practice, story typing, and engaging typing games.';
export const SITE_TAGLINE = 'Type Faster. Learn Smarter. Build Confidence.';

/**
 * Primary navigation links.
 * @type {ReadonlyArray<{ label: string, href: string }>}
 */
export const PRIMARY_NAV = Object.freeze([
  { label: 'Typing Test', href: '/typing-test' },
  { label: 'Learn Typing', href: '/learn-typing' },
  { label: 'Practice', href: '/typing-practice' },
  { label: 'Story Typing', href: '/story-typing' },
  { label: 'Typing Games', href: '/typing-games' },
  { label: 'Leaderboard', href: '/leaderboard' },
]);

/**
 * Footer link groups.
 * @type {ReadonlyArray<{ heading: string, links: ReadonlyArray<{ label: string, href: string }> }>}
 */
export const FOOTER_LINKS = Object.freeze([
  {
    heading: 'Product',
    links: [
      { label: 'Typing Test', href: '/typing-test' },
      { label: 'Typing Lessons', href: '/learn-typing' },
      { label: 'Typing Practice', href: '/typing-practice' },
      { label: 'Story Typing', href: '/story-typing' },
      { label: 'Typing Games', href: '/typing-games' },
      { label: 'Leaderboard', href: '/leaderboard' },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'About', href: '/about' },
      { label: 'Contact', href: '/contact' },
      { label: 'Accessibility', href: '/accessibility' },
    ],
  },
  {
    heading: 'Legal',
    links: [
      { label: 'Privacy Policy', href: '/privacy-policy' },
      { label: 'Terms of Service', href: '/terms' },
      { label: 'Cookie Settings', href: '/cookies' },
    ],
  },
]);

/**
 * Supported typing test durations in seconds.
 * @type {ReadonlyArray<number>}
 */
export const TEST_DURATIONS = Object.freeze([15, 30, 60, 120]);

/**
 * Default test duration in seconds.
 * @type {number}
 */
export const DEFAULT_TEST_DURATION = 60;

/**
 * Accuracy thresholds for lesson completion by difficulty.
 * These are product settings, not universal standards.
 */
export const LESSON_ACCURACY_THRESHOLDS = Object.freeze({
  beginner: 0.90,
  intermediate: 0.92,
  advanced: 0.95,
});